import React from 'react';
import './Hero.css';
import companyLogo from '../assets/icon_logo.webp';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero">
      <div className="hero-background">
        <div className="hero-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>
      </div>
      
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title fade-in-up">
              Creating <span className="gradient-text">Engaging</span><br />
              Hyper-Casual Games
            </h1>
            <p className="hero-subtitle fade-in-up">
              Xi'an Jiutian Chuangxiang Network Technology Co., Ltd. specializes in developing 
              and publishing innovative hyper-casual games that captivate millions of players 
              worldwide on Google Play and App Store.
            </p>
            <div className="hero-buttons fade-in-up">
              <button 
                className="btn btn-primary"
                onClick={() => scrollToSection('games')}
              >
                View Our Games
              </button>
              <button 
                className="btn btn-secondary"
                onClick={() => scrollToSection('contact')}
              >
                Get In Touch
              </button>
            </div>
          </div>
          
          <div className="hero-image">
            <div className="phone-mockup">
              <div className="phone-screen">
                <div className="company-logo-display">
                  <img src={companyLogo} alt="Xi'an Jiutian Chuangxiang Network Technology Co., Ltd. Logo" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
